import React, { FC, useMemo } from 'react';

import { IssuesCount } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';

import { AccessibilityCriticalIssuesChart } from './AccessibilityCriticalIssuesChart';
import { CriticalIssuesData } from './types';

interface AccessibilityCriticalIssuesChartContainerProps {
	data?: IssuesCount[];
	isLoading: boolean;
	error: unknown;
}

export const AccessibilityCriticalIssuesChartContainer: FC<
	AccessibilityCriticalIssuesChartContainerProps
> = ({ data: criticalIssueCount, isLoading, error }) => {
	// Transform IssuesCount[] to CriticalIssuesData[] format expected by the chart
	const chartData = useMemo((): CriticalIssuesData[] | null => {
		if (!criticalIssueCount || criticalIssueCount.length === 0) {
			return null;
		}

		return criticalIssueCount.map((item) => ({
			date: item.day.toISOString().split('T')[0], // Convert to YYYY-MM-DD format
			critical: item.critical,
			serious: item.serious,
			total: item.total
		}));
	}, [criticalIssueCount]);

	return (
		<AccessibilityCriticalIssuesChart
			data={chartData}
			isLoading={isLoading}
			error={error ? 'Failed to load critical issues data' : null}
		/>
	);
};
